<template>
    <div class="ui-timeline">
        <slot></slot>
    </div>
</template>

<script>
    export default {
		name: 'ui-timeline',
		components: {},
		props:{
            
		},
		data() {
            return {
				
            }
		},
		
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
